<template>
  <div class="newsInfo">
    <HeaderNav :lmid="31"/>

    <div class="height"></div>

    <section class="News_info_container">
      <div class="w1520 p95 p95_">
        <div class="box">
          <div class="content1">
            {{ news_info.title }}
          </div>
          <div class="content2">
            {{ (news_info.add_times * 1000) | conversion("yyyy-MM-dd") }}
          </div>
          <div class="content3" v-html="news_info.content"></div>
          <div class="content4 flexBetween">
            <div class="btn prev">
              <router-link
                :to="{ path: '/newsInfo?id=' + news_info.upperId }"
                class="ellipsis"
              >
                上一条 {{ news_info.up_title || "暂无" }}
              </router-link>
            </div>
            <div class="go">
              <router-link to="/news">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.34932 4.85155V2.48553C8.13663 1.49588 7.32628 2.09881 7.32628 2.09881L1.69776 6.95917C0.460261 7.81874 1.61339 8.46561 1.61339 8.46561L7.15753 13.2838C8.26671 14.1012 8.35108 12.8531 8.35108 12.8531V10.6594C13.9796 8.89452 16.2823 15.9521 16.2823 15.9521C16.495 16.3389 16.6233 15.9521 16.6233 15.9521C18.7978 5.36835 8.34932 4.85155 8.34932 4.85155Z"
                    fill="#33BDF1"
                  />
                </svg>
                返回列表
              </router-link>
            </div>
            <div class="btn next">
              <router-link
                :to="{ path: '/newsInfo?id=' + news_info.lowerId }"
                class="ellipsis"
              >
                下一条 {{ news_info.lo_title || "暂无" }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
export default {
  data() {
    return {
      news_info: {},
    };
  },
  beforeMount() {
    this.getNewsInfo();
  },
  watch: {
    $route: {
      handler(to, from) {
        this.getNewsInfo();
      },
      immediate: true,
      // deep: true,
    },
  },
  methods: {
    getNewsInfo() {
      let that = this;
      this.$httpPost("/getAllInfo", {
        typeid: 31,
        aid: this.$route.query.id,
      })
        .then((res) => {
          that.news_info = res;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
